module.exports = __webpack_public_path__ + "img/logo.cd7e5e8b.svg";